import '@fortawesome/fontawesome-free/css/all.min.css';
import React from 'react';
import IMAGES from '../imagesVariable/imagesVariable';
import './Footer.style.scss';

const Footer = () => (
  <footer className="footer">
    <div className="footer__content">
      <div className="footer__sections">
        <div className="footer__section">
          <h3>About</h3>
          <ul>
            <li><a href="/about">Mission & Vision</a></li>
            <li><a href="/library_hours">Hours & Location</a></li>
            {/* <li><a href="/privacy_policy">Policies</a></li> */}
            <li><a href="/about">About the Library</a></li>
          </ul>
        </div>
        <div className="footer__section">
          <h3>Resources</h3>
          <ul>
            <li><a href="https://opac.juniv.edu/">Catalog</a></li>
            <li><a href="https://opac.juniv.edu/cgi-bin/koha/opac-search.pl">Classic Catalog</a></li>
            <li><a href="https://journals.juniv.edu">Ju Journals</a></li>
            <li><a href="https://repository.juniv.edu">Institutional Repository</a></li>
          </ul>
        </div>
        <div className="footer__section">
          <h3>Help</h3>
          <ul>
            <li><a href="https://library.juniv.edu/citizen_charter">Ask A Librarian</a></li>
            <li><a href="/faq">FAQs</a></li>
          </ul>
        </div>
      </div>
      <div className="footer__contact">
      <img src={IMAGES.songsoptok} alt='' />
        <a href="mailto:library@juniv.edu" className="footer__contact-button">Contact Us</a>
        <div className="footer__contact-info">
          <strong>University Library, Jahangirnagar University</strong><br />
          Savar, Dhaka-1342<br />
          <a href="tel:02224491045">02224491045-51 (Ext.1244, 2275)</a><br />
          <a href="mailto:library@juniv.edu">library@juniv.edu</a>
        </div>
        <br />
        <div className="footer__social">
        <a href="https://www.facebook.com/p/University-Library-JU-100064702583896/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
        <a href="https://x.com/library_JUniv" target="_blank" rel="noopener noreferrer"><i className="fab fa-x"></i></a>
        <a href="https://www.instagram.com/library_juniv/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
        <a href="mailto:library@juniv.edu"><i className="fas fa-envelope"></i></a>
      </div>
      
      </div>
    </div>
    <div className="footer__bottom">
      <p>© 2026 University Library, Jahangirnagar University</p>
    </div>
  </footer>
);

export default Footer;
